
import { Link } from "react-router-dom";

const SecondaryButton = ({title, onClick, className, href = ''}) => {
    return (
        <>
            {href !== '' ?
                <Link to = {href} className={`text-20px 2xl:text-xl px-4 py-3 rounded-[7px] w-fit bg-transparent text-main hover:text-white hover:bg-main border-[1px] border-main ${className}`}>
                    {title}
                </Link>
            :(
                <button onClick = {onClick} className={`bg-transparent text-main hover:text-white hover:bg-main border-[1px] border-main text-20px 2xl:text-xl px-4 py-3 rounded-[7px] w-fit ${className}`}>
                    {title}
                </button>
            )}
        </>
    );
}

export default SecondaryButton;